// src/components/layout/Layout.jsx
import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import SelectedMedicalCenter from './SelectedMedicalCenter';

const Layout = ({ children }) => {
  const location = useLocation();

  // Only show the chip on MC-scoped pages (/medical_centers/:id/...)
  const onSelectionPage = !!matchPath({ path: '/medical_centers', end: true }, location.pathname);
  const showCenterChip = !onSelectionPage;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header - Fixed at top */}
      <Header />
      
      <div className="flex flex-1">
        {/* Sidebar - Left Navigation */}
        <Sidebar />
        
        {/* Main Content Area */}
        <div className="flex-1 flex flex-col">
          {/* Page Content - Takes available space */}
          <main className="flex-1 p-6 overflow-y-auto">
            {showCenterChip && <SelectedMedicalCenter />}
            {children}
          </main>
        </div>
      </div>
      
      {/* Footer - Fixed at bottom */}
      <Footer />
    </div>
  );
};

export default Layout;